import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Community } from '@app/_models/community';
import { MessageResponse } from '@app/_models/responses';
import { Property } from '@app/_models/propery.model';

@Injectable({ providedIn: 'root' })
export class PropertyService {
    constructor(private http: HttpClient) { }

    getAll() {
        //return this.http.get<Community[]>(`${environment.apiUrl}/api/communities`);
        return this.http.get<Property[]>(`${environment.apiUrl}/api/property`);
    }

    checkSubscriptions(username: string) {
        //return this.http.get<Community[]>(`${environment.apiUrl}/api/user/community/subscriptions/` + username)
        return this.http.get<Property[]>(`${environment.apiUrl}/api/user/property/subscriptions/` + username)

    }

    requestAccess(formdata: any) {
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');

        return this.http.post<MessageResponse>(`${environment.apiUrl}/api/access/request`, formdata, { headers : header});
    }
}